import React, { Component } from 'react';
import style from './MultipleCheckedWithLabel.module.css';
import uuid from 'react-uuid';
// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class MultipleCheckedWithLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //dataList: []
        };
        //if (this.props.value !== undefined) this.state.dataList = this.props.value;
    }
    renderInput() {
        let dataList = []
        if (this.props.value !== undefined){
            dataList = this.props.value;
        }


        let item = [];
        //alert("render");
        for (let i = 0; i < dataList.length; i++) {
            let node = dataList[i];
            //alert(node.IsSelect);
            item.push(
                <div className={style.rowcheck} key ={uuid()}  >
                    <label>

                        <input
                            id = {i}
                            type="checkbox"
                            name={this.props.name}
                            checked={node.IsSelect}
                            onChange={this.props.onChange}
                        />
                        {node.Label}
                    </label>
                </div>
            );
        }
        return item;
    }
    render() {
        let inputList = this.renderInput();
        return (
            <div className={style.area}>
                <div className={style.title}>
                    {this.props.label}
                </div>
                    {inputList}
            </div>
        );
    }
}
export default MultipleCheckedWithLabel